import { ReactElement, useCallback, useContext, useEffect, useState } from 'react';
import SmartAssistant from './SmartAssistant';
import { CloseOutlined } from '@ant-design/icons';
import aiStyles from '@/styles/pages/admin/ai.module.less';
import { useTranslation } from '@/services';
import { getAccountBalance } from '@/services/api/tokenRecharge';
import { formatCurrency } from '@/utils';
import { AiComponentContext } from '@/context';
import { getTodayAiPoints } from '@/services/api/ai';
const SmartAssistantContainer = (): ReactElement => {
    const { t } = useTranslation('admin', 'admin.aIcade-score');
    const { visible, setVisible } = useContext(AiComponentContext);
    const [accountBalance, setAccountBalance] = useState('0.00');
    const [todayPointsUsed, setTodayPointsUsed] = useState<number>(0);
    const init = useCallback(async () => {
        if (visible) {
            const data = await getAccountBalance();
            setAccountBalance(data.balance);
            const todayPoints = await getTodayAiPoints();
            setTodayPointsUsed(todayPoints.price);
        }
    }, [getAccountBalance, visible]);
    // 延迟执行
    useEffect(() => {
        init();
    }, [init]);
    return (
        <>
            {visible && (
                <div className={aiStyles['assistant-popup']}>
                    <div className={aiStyles['assistant-popup-header']}>
                        <div className={aiStyles['assistant-popup-header-left']}>
                            <span>AIcade Galaxy AI</span>
                            {/* 钱包余额 */}
                            <div className={aiStyles['assistant-popup-header-left-balance']}>
                                {/* {t('wallet-balance')}:
                                <span>
                                    <TokenBalanceFmt token={contractConstants.Registries.AGSToken} />
                                </span> */}
                                <span></span>
                                {t('account-balance')}:<span>{formatCurrency(Number(accountBalance))}</span>
                                <span></span>
                                today used:<span>{todayPointsUsed}</span>
                            </div>
                        </div>
                        <span className={aiStyles['assistant-close-button']} onClick={() => setVisible(false)}>
                            <CloseOutlined />
                        </span>
                    </div>
                    <SmartAssistant />
                </div>
            )}
        </>
    );
};

export default SmartAssistantContainer;
